import { GAME_TYPE, QUESTION_TYPE } from "../constants";

const baseRoute = (name = "") => {
  return `${process.env.REACT_APP_DOMAIN_DIR}/${name}`;
};

const apiBaseUrl = () => {
  return process.env.REACT_APP_API_DOMAIN + "api/user/";
};

const localStorageToken = () => {
  return process.env.REACT_APP_WEB_STORAGE_TOKEN;
};

const formatDateTime = (dt) => {
  const date = new Date(dt);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")} ${String(
    date.getHours()
  ).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}:00`;
};

const formatUTCDateToLocal = (dateString, formatOptions = {}) => {
  if (!dateString) return "---";
  const date = new Date(dateString);
  return date.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...formatOptions,
  });
};

// Trip Status
const TRIP_STATUS_LIST = [
  { label: "SCHEDULED", value: 10 },
  { label: "IN_PROGRESS", value: 20 },
  { label: "COMPLETED", value: 30 },
  { label: "CANCELLED", value: 40 },
];

const getTripStatus = (status) => {
  const item = TRIP_STATUS_LIST.find((type) => type.value === status);
  return item ? item.label : "";
};

// Trip Stop Type
const TRIP_STOP_TYPE_LIST = [
  { label: "SCHEDULED", value: 10 },
  { label: "EMERGENCY", value: 20 },
];

const getTripStopType = (type) => {
  const item = TRIP_STOP_TYPE_LIST.find((t) => t.value === type);
  return item ? item.label : "";
};

// Trip Stop Status
const TRIP_STOP_STATUS_LIST = [
  { label: "SCHEDULED", value: 10 },
  { label: "ARRIVED", value: 20 },
  { label: "COMPLETED", value: 30 },
  { label: "CANCELLED", value: 40 },
];

const getTripStopStatus = (status) => {
  const item = TRIP_STOP_STATUS_LIST.find((t) => t.value === status);
  return item ? item.label : "";
};

// Trip Stop Student Status
const TRIP_STOP_STUDENT_STATUS_LIST = [
  { label: "PENDING", value: 10 },
  { label: "BOARDED", value: 20 },
  { label: "DEBOARDED", value: 30 },
];

const getTripStopStudentStatus = (status) => {
  const item = TRIP_STOP_STUDENT_STATUS_LIST.find((t) => t.value === status);
  return item ? item.label : "";
};

// Route Type
const ROUTE_TYPE_LIST = [
  { label: "PICKUP", value: 10 },
  { label: "DROP_OFF", value: 20 },
];

const getRouteType = (type) => {
  const item = ROUTE_TYPE_LIST.find((t) => t.value === type);
  return item ? item.label : "";
};

export const TRIP_STATUS = {
  SCHEDULES: 10,
  IN_PROGRESS: 20,
  COMPLETED: 30,
  CANCELLED: 40,
};

export const TRIP_STOP_TYPE = {
  SCHEDULED: 10,
  EMERGENCY: 20,
};

export const TRIP_STOP_IMAGES = {
  home: "/images/marker/home.png",
  vehicle: "/images/marker/vehicle.png",
  blue: "/images/marker/blue.png",
  red: "/images/marker/red.png",
  default: "/images/marker/red.png",
};

export const TRIP_ROUTE_TYPE = {
  PICKUP: 10,
  DROP_OFF: 20,
};

export const TRIP_VEHICLE_TYPE = {
  BUS: "bus",
  MINI_BUS: "mini_bus",
  VAN: "van",
};

export const EMERGENCY_SERVICE = {
  BREAKDOWN: 1,
  PERSONAL: 2,
};

export const ROUTE_STOP_STATUS = {
  PICKEDUP: "PICKEDUP",
  NOTPICKED: "NOTPICKED",
  INCOMPLETESTOP: "INCOMPLETESTOP",
  ONTIMEPICKUP: "ONTIMEPICKUP",
  STOPPED: "STOPPED",
};

export {
  formatDateTime,
  formatUTCDateToLocal,
  baseRoute,
  apiBaseUrl,
  localStorageToken,
  TRIP_STATUS_LIST,
  TRIP_STOP_STATUS_LIST,
  TRIP_STOP_TYPE_LIST,
  TRIP_STOP_STUDENT_STATUS_LIST,
  ROUTE_TYPE_LIST,
  getTripStopType,
  getTripStopStatus,
  getTripStopStudentStatus,
  getTripStatus,
  getRouteType,
};
